import { api } from "@/api";
import {
  UpsertBettingSelectionSuspensionsParams,
  BettingSelectionSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingSelection";

export const upsertBettingSelectionsSuspensions = async (
  data: UpsertBettingSelectionSuspensionsParams
): Promise<BettingSelectionSuspensionsEditorResponse> => {
  const res = await api.client.post(`/betting-selections-new/suspensions`, data);
  return res.data;
};
